import { Component } from '@angular/core';

@Component({
  selector: 'ni-dialog-title',
  template: '<ng-content></ng-content>'
})
export class DialogTitleComponent {}
